import {makeStateKey, TransferState} from "@angular/platform-browser";
import { Inject, Injectable, NgZone } from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import {Observable, of, tap} from "rxjs";
import * as memoryCache from 'memory-cache';
import { Environment, ENVIRONMENT } from '@nx-averycom/environment';


@Injectable()
export class ServerStateInterceptor implements HttpInterceptor {

  constructor(@Inject(ENVIRONMENT) private env: Environment, private transferState: TransferState, private ngZone: NgZone) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.method === 'GET' && !req.urlWithParams.includes(this.env.dpo)) {
      const cachedData = memoryCache.get(req.urlWithParams);

      if (cachedData) {
        this.transferState.set(makeStateKey(req.urlWithParams), cachedData);
        return of(new HttpResponse(({body: cachedData, status: 200})));
      }
    }

    return next.handle(req).pipe(
      tap(event => {

        if (event instanceof HttpResponse) {
          this.transferState.set(makeStateKey(req.urlWithParams), event.body)
          this.ngZone.runOutsideAngular(() => {
            memoryCache.put(req.urlWithParams, event.body, 6000*5);
          });
        }
      })
    )
  }
}
